'use client';
// use client because of mui

import { Container } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

import { HeaderBar, Snackbar } from '..';
import { Sidebar } from '../../common';

import styles from './MainLayout.module.scss';

type MainLayoutProps = {
  isAuthorized: boolean;
};

export const MainLayout: FC<PropsWithChildren<MainLayoutProps>> = (props) => {
  const { isAuthorized, children } = props;

  return (
    <Container disableGutters maxWidth={false} sx={{ display: 'flex' }}>
      <Sidebar isAuthorized={isAuthorized} />

      <div className={styles.pageContent}>
        <Snackbar classes={{ containerRoot: styles.snackbarContainerRoot }} />

        <HeaderBar isAuthorized={isAuthorized} />

        <Container disableGutters maxWidth={false} className={styles.pageContainer}>
          {children}
        </Container>
      </div>
    </Container>
  );
};
